export default __webpack_public_path__ + "static/media/template.e57dadb7.xlsx";